import TachographCardsList from "./TachographCardsList";

const TachographCardsPage = () => <TachographCardsList />;

export default TachographCardsPage;
